<p-tabView (onChange)="onTabChange($event)" [ngClass]="{'gltab': visibleFromModule != 'Finance'}">
    <p-tabPanel header="Overview">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-2">
                    <p><strong>Number: </strong></p>
                    <p><strong>Transfer From: </strong></p>
                </div>
                <div class="p-col-4">
                    <p>{{transferDetail?.number}}</p>
                    <p>{{transferDetail?.sourceWarehouseName}}</p>
                </div>
                <div class="p-col-2">
                    <p><strong>Transfer To: </strong></p>
                    <p><strong>Posting Period: </strong></p>
                </div>
                <div class="p-col-4">
                    <p>{{transferDetail?.destinationWarehouseName}}</p>
                    <p>{{transferDetail?.postingDate ? (transferDetail?.postingDate | date: 'MMMM yyyy') : null}}</p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <p-table [value]="transferDetail?.inventoryTransferProductDetail">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Product Name</th>
                                <th>From Bin</th>
                                <th>Bin QOH</th>
                                <th>Destination Qty</th>
                                <th>Transfer Qty</th>
                                <th>To Bin</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-detail>
                            <tr>
                                <td>{{detail.productName}}</td>
                                <td>{{detail.sourceBinName}}</td>
                                <td>{{detail.sourceTotalQty | customNumberFormat: qtyDecimal }}</td>
                                <td>{{detail.destinationTotalQty | customNumberFormat: qtyDecimal }}</td>
                                <td>{{detail.totalTransferQty | customNumberFormat: qtyDecimal }}</td>
                                <td>{{detail.destinationBinName}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-2">
                    <p><strong>Comments: </strong></p>
                </div>
                <div class="p-col-10">
                    <p>{{transferDetail?.comment}}-- ({{transferDetail?.createdByUser}}-{{transferDetail?.createdDate | date: 'MM/dd/yyyy'}})</p>
                </div>
            </div>
        
        </div>

        <p-toast position="top-right" [baseZIndex]="10000"></p-toast>
    </p-tabPanel>
    <p-tabPanel header="Impacts on G/L">
        <app-inventory-impacts-gl [selectedId]="inventoryTransferId" [objectTypeId]="transactionTypeIds.InventoryTransfer" [callApi]="glApiCall"></app-inventory-impacts-gl>
    </p-tabPanel>   
</p-tabView>